module.exports = __webpack_public_path__ + "img/8.202521a0.png";